import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import ModalPopup from '@ui/components/VnModal';
import { addOutline } from 'ionicons/icons';
import { useState } from 'react';
import AddInstructionForm from './AddInstructionForm';
import RepairInstructionTable from './RepairInstructionTable';
import { getDebtorSpecificationbyIdAsync } from '@application/features/debtors/debtorThunk';
import { useAppDispatch } from '@application/store/useStore';
import { clearDebtorSpecification } from '@application/features/debtors/debtorSlice';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
const RepairInstructionsTab = ({ isRepairInstructionsTabBold }) => {
    const dispatch = useAppDispatch();
    const [isAddInformationFormVisible, setIsAddInformationFormVisible] = useState(false);
    const onAddInformationFormCloseClicked = () => {
        dispatch(clearDebtorSpecification());
        setIsAddInformationFormVisible(false);
    };
    const onRowClick = (id) => {
        dispatch(getDebtorSpecificationbyIdAsync(id));
        setIsAddInformationFormVisible(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'vn-Material-Add-buttons', children: _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'vn-add-button mt-1 mb-3 ml-2', icon: addOutline, isDisabled: !handleRolePermission(Permission.KLANTEN, PermissionType.Create), onClick: () => {
                        setIsAddInformationFormVisible(true);
                    }, children: "Toevoegen Voorschriften" }) }), _jsx(ModalPopup, { title: 'Toevoegen Voorschriften', content: _jsx(AddInstructionForm, { onClose: () => onAddInformationFormCloseClicked(), isRepairInstructionsTabBold: isRepairInstructionsTabBold }), onOpen: isAddInformationFormVisible, onClose: () => onAddInformationFormCloseClicked(), modalWidth: 'lg' }), _jsx(RepairInstructionTable, { onRowClick: onRowClick, isRepairInstructionsTabBold: isRepairInstructionsTabBold })] }));
};
export default RepairInstructionsTab;
